import React from "react";
import { DashboardRenderDurationEntity } from "../dashboard-render-duration-entity/dashboard-render-duration-entity";

export function PostmatchTableRenderDuration() {
  return function (text: string) {
    return <DashboardRenderDurationEntity text={text} />;
  };
}
